import { useEffect, useMemo, useState } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadFireworksPreset } from "@tsparticles/preset-fireworks";

let fireworksEnginePromise = null;

function ensureFireworksEngine() {
  if (!fireworksEnginePromise) {
    fireworksEnginePromise = initParticlesEngine(async (engine) => {
      await loadFireworksPreset(engine);
    });
  }
  return fireworksEnginePromise;
}

/**
 * Capa a pantalla completa con preset fireworks de tsParticles.
 * Se desmonta sola tras `durationMs` (vista pública onboarding).
 */
export default function OnboardingSlideEnterFireworks({ playId, durationMs = 12000, onEnded }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    ensureFireworksEngine().then(() => {
      if (!cancelled) setReady(true);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!playId || !ready) return;
    const t = window.setTimeout(() => {
      onEnded?.();
    }, durationMs);
    return () => window.clearTimeout(t);
  }, [playId, ready, durationMs, onEnded]);

  const options = useMemo(
    () => ({
      preset: "fireworks",
      fullScreen: {
        enable: true,
        zIndex: 10050,
      },
      background: {
        color: {
          value: "transparent",
        },
      },
      sounds: {
        enable: false,
      },
    }),
    []
  );

  if (!ready || !playId) return null;

  return <Particles id={`ob-fireworks-${playId}`} options={options} />;
}
